import type { InstallationServiceData } from '@coolblue-development/next-installation-services';

import { ExtendedUsp } from './types';

const FREE_SALES_PRICE = 0;
const PLACE_AND_CONNECT = 15;

export const GetPreSelectedServiceUsps = (
  services: InstallationServiceData[] | null
): ExtendedUsp[] => {
  if (!services || services.length === 0) {
    return [];
  }

  const preSelectedService =
    services.findLast(
      service =>
        service.salesPrice.includingVat === FREE_SALES_PRICE &&
        service.installServiceTypeId === PLACE_AND_CONNECT
    ) ?? services.find(service => service.isPreselected);

  if (!preSelectedService || !preSelectedService.extendedUsps) {
    return [];
  }

  return preSelectedService.extendedUsps;
};
